export const STYLE_INJECTION_CONTAINER_ID = 'epilot-injected-styles'
